import React from "react";
import TollCollection from "./Common/TollCollection";

function MelliDashboard() {
  return (
    <div className="row m-0">
      <div className="col col-12 col-md-6 col-lg-6">
        <div className="graph-outline mb-3">
          <TollCollection />
        </div>
      </div>
    </div>
  );
}

export default MelliDashboard;
